import { Repeat } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
    currentCycledDomain,
    nextCycledDomain,
    type CycledDomain,
} from '@/utils/drill-taxonomy';

interface DomainCycleButtonProps {
    selectedDomains: Iterable<string> | undefined;
    onCycle: (next: CycledDomain) => void;
    className?: string;
    testId?: string;
}

/**
 * Cycles the Domain filter through Weightroom → Positional → Rolling.
 */
export function DomainCycleButton({
    selectedDomains,
    onCycle,
    className = '',
    testId = 'drill-library-domain-cycle',
}: DomainCycleButtonProps) {
    const current = currentCycledDomain(selectedDomains);
    const label = current ?? 'All';

    return (
        <Button
            type="button"
            variant="outline"
            size="sm"
            className={`h-10 gap-1.5 px-3 ${className}`}
            onClick={() => onCycle(nextCycledDomain(current))}
            data-testid={testId}
            title="Cycle Weightroom, Positional, Rolling"
        >
            <Repeat className="h-4 w-4 shrink-0" />
            <span className="text-xs font-medium whitespace-nowrap">{label}</span>
        </Button>
    );
}
